import { Receipt } from 'lucide-react';
import { TOTAL_MILESTONES } from '../config/onboarding.config';

interface ProgressRingProps {
  /** Hitos completados (0 a 4). */
  value: number;
  /** Diámetro en px. */
  size?: number;
  strokeWidth?: number;
  className?: string;
}

/**
 * Anillo de progreso con el ícono de comprobante al centro.
 * Al completarse pasa de azul de marca a verde de éxito.
 * El riel usa --ring-track: más visible que --surface-2 sobre blanco.
 */
export function ProgressRing({
  value,
  size = 34,
  strokeWidth = 2.5,
  className = '',
}: ProgressRingProps) {
  const radius = size / 2 - strokeWidth / 2 - 1.5;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (circumference * value) / TOTAL_MILESTONES;
  const isComplete = value >= TOTAL_MILESTONES;

  const iconSize = Math.round(size * 0.4);

  return (
    <span
      className={`relative shrink-0 ${className}`}
      style={{ width: size, height: size }}
      role="img"
      aria-label={`${value} de ${TOTAL_MILESTONES} pasos completados`}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="-rotate-90 block">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          strokeWidth={strokeWidth}
          className="stroke-[var(--ring-track)]"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className={[
            'transition-[stroke-dashoffset,stroke] duration-500 ease-out',
            isComplete ? 'stroke-[var(--success)]' : 'stroke-[var(--primary)]',
          ].join(' ')}
        />
      </svg>
      <span
        className={[
          'absolute inset-0 flex items-center justify-center transition-colors duration-300',
          isComplete ? 'text-success' : 'text-brand',
        ].join(' ')}
      >
        <Receipt style={{ width: iconSize, height: iconSize }} strokeWidth={1.8} />
      </span>
    </span>
  );
}
